import { getApiVersion, http } from '@vt/apis/lib-ex'

export const fetchcConfigData = (appId, tpl) => {
  return http()
    .get(
      `${getApiVersion()}/apps/${appId}/informationStorage/my?purpose=screen&tpl=${tpl}`
    )
    .json()
}
